module.exports = __webpack_public_path__ + "static/schaukel07-6585ac89210fc86c0e9e82bb8c3ded19.jpg";